import { ProblemType } from '@/static/enums/problemType';

/**
 * Map of string arrays that include instructions to fix the problem of given type.
 */
export const ProblemTypeToInstructionLines: Record<ProblemType, string[]> = {
  // Validation errors are already given in header of case and not in problems tab.
  // So there is no need for any instructions here.
  [ProblemType.VALIDATION_ERRORS]: [],
  [ProblemType.NOT_OPENED_IN_TARN]: [
    'Parandage toimikus esinevad vead.',
    'Vajutage päises nuppu "Saada E-Täiturisse", et menetluse avamist korrata.',
  ],
  [ProblemType.NOT_NOT_CLOSED_IN_TARN]: [
    'Parandage toimikus esinevad vead.',
    'Proovige ebaõnnestunud lõpetamist "Päringud" saki alt korrata vajutades "Uuesti".',
  ],
  [ProblemType.NOT_IN_SYNC_WITH_TARN]: [
    'Parandage toimikus võimalikud esinevad vead.',
  ],
  [ProblemType.NOT_NOT_STOPPED_IN_TARN]: [
    'Parandage toimikus esinevad vead.',
    'Proovige ebaõnnestunud peatamist "Päringud" saki alt korrata vajutades "Uuesti".',
  ],
  [ProblemType.NOT_NOT_UNSTOPPED_IN_TARN]: [
    'Parandage toimikus esinevad vead.',
    'Proovige ebaõnnestunud peatamise lõpetamist "Päringud" saki alt korrata vajutades "Uuesti".',
  ],
  [ProblemType.NOT_NOT_REOPENED_IN_TARN]: [
    'Parandage toimikus esinevad vead.',
    'Proovige ebaõnnestunud taasavamist "Päringud" saki alt korrata vajutades "Uuesti".',
  ],
  [ProblemType.NOT_NOT_PARTIALLY_CLOSED_IN_TARN]: [
    'Parandage toimikus esinevad vead.',
    'Proovige ebaõnnestunud osalist lõpetamist "Päringud" saki alt korrata vajutades "Uuesti".',
  ],
  [ProblemType.NOT_IN_SYNC_WITH_TR_OPENED]: [
    'Kui toimiku alustamine on Täitmisregistris vea tõttu ebaõnnestunud, siis:\n     1) Parandage viga või võtke vajadusel ühendust administraatoriga.\n     2) Proovige ebaõnnestunud alustamist "Päringud" saki alt korrata vajutades "Uuesti".',
    'Muul juhul võtke ühendust administraatoriga.'
  ],
  [ProblemType.NOT_IN_SYNC_WITH_TR_CLOSED]: [
    'Parandage toimikus esinevad vead.',
    'Proovige ebaõnnestunud lõpetamist "Päringud" saki alt korrata vajutades "Uuesti".',
  ],
  [ProblemType.NOT_IN_SYNC_WITH_TR_OTHER]: [
    'Parandage toimikus esinevad vead.',
    'Proovige ebaõnnestunud tegevust "Päringud" saki alt korrata vajutades "Uuesti".',
  ],
};
